import { render, staticRenderFns } from "./ProfileLocations.vue?vue&type=template&id=abf68096&scoped=true&"
import script from "./ProfileLocations.vue?vue&type=script&lang=js&"
export * from "./ProfileLocations.vue?vue&type=script&lang=js&"
import style0 from "./ProfileLocations.vue?vue&type=style&index=0&id=abf68096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf68096",
  null
  
)

export default component.exports